import { createGlobalStyle } from 'styled-components';
import base from './base';

const baseStyles = createGlobalStyle`
    ${base}
`;

export default baseStyles;
